/* Models */
import { AppData } from '../../models/app-data.model';
import { Node } from '../../models/node.model';
import { TreeNode } from '../../models/tree-node.model';

export class SetData {
	static readonly type = '[App] Set app data';
	constructor(public data: AppData) {}
}

export class SetActiveNode {
	static readonly type = '[App] Set active node';
	constructor(public activeNode: TreeNode) {}
}

export class SetNodeTree {
	static readonly type = '[App] Set node tree';
	constructor(public nodes: Node[]) {}
}

export class UpdateUserAccount {
	static readonly type = '[App] Update user account';
	constructor(public field: string, public value: any, public dataType: string) {}
}

export class ResetAppData {
	static readonly type = '[App] Reset app data';
}
